import styled from "styled-components";
import { styled as muiStyled } from '@mui/material/styles';
import { dark, thirdly } from "styles/theme";
import { Center, Scroll } from "styles/GlobalCss";
import { white } from "styles/theme";
import { Box, SvgIcon } from "@mui/material";
import { fontSize } from "@mui/system";

const RateAndAccuracyDescription = styled.div`
`

const WrapGraphTexts = styled.div`
display:flex;
flex-direction: column;
width: 70px;
font-size:15px;
row-gap:10px;

.wrap-graph-text{
display: flex;
height:38px;
column-gap:5px;
align-items: center;
}

.graph-text{
width:70px;
}

.graph-icon{
transform:rotate(180deg);
}
`

const ChildrenGraphStyles = muiStyled(Box)(({ isSlider, fullWidth, isDrag, theme }) => ({
    display: "flex",
    height: isSlider && 100,
    columnGap: 15,
    '.wrap-rating-group': {
        flexGrow: fullWidth ? 1 : 0
    },
    '.wrap-rating-group2': {
        display: "flex",
        justifyContent: "space-between"
    },
    '.no-data': {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: 18
    },
    '.source-item': {
        transform: 'translateZ(0px)',
        flexShrink: 0,
        zIndex: 3
    },
    '#source-item2': {
        position: "absolute",
        right: 11,
        zIndex: 2
    },
    '.wrap-bar': {
        flexGrow: 1,
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        overflow: "auto"
    },
    '.arrow': {
        width: 40,
        cursor: "pointer"
    },
    '.dragging': {
        cursor: "grabbing"
    },
    '.children-count': {
        display: "flex",
        columnGap: 3,
        color: dark,
        direction: "ltr"
    },
    '.items-count': {
        position: "relative",
        right: 13
    }

}))

const LineStyles = muiStyled(Box)(({ showAllChildren, theme, color, firstItem }) => ({
    color: color,
    position: "relative",
    bottom: 36,
    display: "flex",
    justifyContent: "center",
    '.line': {
        height: 2,
        width: "100%",
        background: color,
        marginTop: 5,
        marginBottom: 5
    },
    '.wrap-line': {
        height: "25px",
        textAlign: "center",
        width: "100%",
        alignItems: "center",
        position: "relative"
    },
    'path': {
        fill: color
    },
    '.rating-details': {
        fontSize: 14,
        position: "relative",
        right: firstItem ? 0 : 13,
        height: 25,
        display: "flex",
        justifyContent: "center"
    },
    '.count': {
        height: 40,
        alignItems: "center",
        justifyContent: "start",
        flexDirection: "column"
    },
    '.percent': {
        alignItems: "end"
    }
}))

const DraggableCircleStyles = muiStyled(Box)(({ percent, color, hide, showChildren, colors, zIndex }) => ({
    top: showChildren && 50,
    background:
        hide ? "transparent" :
            `linear-gradient( -90deg, ${colors[0]}, ${colors[1]} 49%,  ${colors[2]} 51%, ${colors[3]} 51% )`,
    borderRadius: 30,
    position: "relative",
    bottom: 6,
    // right: percent && 4,
    zIndex: zIndex || 10,
    width: 30,
    height: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 30,
    '.circle-content': {
        textAlign: "center",
        color: color,
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        fontSize: 13,
        borderRadius: 30,
        height: 22,
        width: 22,
        background: "white"
    }
}))

const DraggableStyles = muiStyled(Box)(({ fullWidth, itemWidth, theme }) => ({
    width: itemWidth,
    flexGrow: fullWidth && 1,
    display: "flex",
    flexDirection: "column",
    '.draggable-item': {
        width: "100%",
        transform: 'translateZ(0px)',
        flexShrink: 0,
        zIndex: 5
    },
    '.draggable-item2': {
        width: "100%",
        height: "100%",
        display: "flex",
        position: "absolute"
    },
    '.draggable-item3': {
        width: "100%",
        height: "100%",
        display: "flex"
    }
}))


const WrapNumChild = styled.div`
font-size:11px;
height:${props => props.viewTestTaker && props.viewItemCount ? 29 : 18}px;
color:${props => props.theme.color};
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
direction: rtl;
padding: 4px 2px;
box-sizing: border-box;
text-align:center;
display:flex;
justify-content:start;
align-items:center;
flex-direction:column
`

const WrapIcon = styled(SvgIcon)`
width:20px !important;
height:20px !important;
path{
fill:${props => props.theme.color} !important;
}
`

const WrapGraphItem = styled.div`
flex-grow: 1;
display: flex;
flex-direction: column;
height:${props => props.viewTestTaker && props.viewItemCount ? 97 : 80}px;

${props => props.current_test_taker && `
 border-radius:8px;
 border:1px solid ${thirdly};
 border-bottom-left-radius: 0px;
 border-bottom-right-radius: 0px;
`} 
`

const WrapChild = styled.div`
height:37px;
${Center};
justify-content:center;
position: relative;
`

const GraphNumber = styled.span`
align-items:center;
height: 35px;
color:${props => props.theme.isDrag ? props.theme.textColor : props.theme.color};
width: 100%;
background:${props => props.theme.isDrag ?
        props.theme.firstRatingItem ?
            `linear-gradient( -90deg, ${props.theme.lightColor}, ${props.theme.lightColor} 49%,  ${props.theme.prevLightColor} 51%, ${props.theme.prevLightColor} 51% )`
            : props.theme.lightColor :
        white};
display: flex;
justify-content: center;
flex-direction: column;
font-size:${props => props.size == "large" ? 18 : 12}px;
font-weight:${props => props.bold && "bold"}
`

const WrapGraph = styled.span`
opacity:${props => props.disabled && "0.5"};
flex-grow:1;
overflow-y:hidden;
overflow-x:auto;
display:flex;
direction: ltr;
align-items: center;
width:100%;
${Scroll};
`

export { DraggableCircleStyles, DraggableStyles, LineStyles, WrapGraphTexts, ChildrenGraphStyles, RateAndAccuracyDescription, WrapNumChild, WrapIcon, WrapChild, WrapGraphItem, WrapGraph, GraphNumber }